import { OPCOES_SEXO, type Sexo } from "@/shared/lib/sexo";

interface CampoSexoProps {
  /** "masculino" | "feminino" | "" (nada marcado). */
  valor: string;
  onChange: (valor: Sexo) => void;
  erro?: string;
  /** `name` do grupo (a tela pode ter vários, como os familiares dos Visitantes). */
  name?: string;
  legenda?: string;
  ajuda?: string;
}

/**
 * Escolha de Sexo: dois botões lado a lado, nada marcado de início (ninguém escolhe sem querer).
 * Mesmo desenho do `EscolhaSimNao` dos Visitantes. Botões de rádio de verdade: teclado e leitor de
 * tela funcionam. Aprovado no protótipo "Campo Sexo no Elos" (02/11/2026).
 */
export function CampoSexo({
  valor,
  onChange,
  erro,
  name = "sexo",
  legenda = "Sexo",
  ajuda,
}: CampoSexoProps) {
  return (
    <fieldset className="flex flex-col gap-1.5" aria-describedby={erro ? `${name}-erro` : undefined}>
      <legend className="text-sm font-medium tracking-wide text-text">{legenda}</legend>
      {ajuda && <p className="text-xs text-muted">{ajuda}</p>}
      <div className="mt-1.5 grid grid-cols-2 gap-2">
        {OPCOES_SEXO.map((opcao) => (
          <label key={opcao.chave} className="relative block">
            <input
              type="radio"
              name={name}
              checked={valor === opcao.chave}
              onChange={() => onChange(opcao.chave)}
              className="peer sr-only"
            />
            <span
              className="flex min-h-11 cursor-pointer items-center justify-center rounded-md border border-border bg-surface-2 px-3 text-center text-sm font-semibold text-muted transition-colors peer-checked:border-primary peer-checked:bg-primary peer-checked:text-on-primary peer-focus-visible:ring-2 peer-focus-visible:ring-primary"
            >
              {opcao.rotulo}
            </span>
          </label>
        ))}
      </div>
      {erro && (
        <span id={`${name}-erro`} role="alert" className="text-xs text-danger">
          {erro}
        </span>
      )}
    </fieldset>
  );
}
